module.exports = __webpack_public_path__ + "img/chakanbingli.3bab99b8.png";